const VIEWER = "閲覧のみ";
const NORMAL_USER = "一般ユーザー";
const ORDER_USER = "発注担当者";
const HUMAN_RESOURCE_USER = "人事担当者";
const ADMINISTRATOR = "システム管理者";
export const PERMISSIONS = {
  NORMAL_USER,
  VIEWER,
  HUMAN_RESOURCE_USER,
  ADMINISTRATOR,
  ORDER_USER,
};
export const PERMISSIONS_LIST = [
  { id: VIEWER, name: VIEWER },
  { id: ORDER_USER, name: ORDER_USER },
  { id: NORMAL_USER, name: NORMAL_USER },
  { id: HUMAN_RESOURCE_USER, name: HUMAN_RESOURCE_USER },
  { id: ADMINISTRATOR, name: ADMINISTRATOR },
];
